import type { ReactElement } from 'react';
import { PackageContainer } from '../common/PackageContainer';
import { PackageDetails } from '../common/PackageDetails';
import { PackageGroup } from '../common/PackageGroup';
import { PackagesByCategory } from '../common/PackagesByCategory';
import { CelebrationPackageCategoryLabels } from 'packages/enums';
import type {
  CelebrationPackage,
  Service,
  PackageSelectComponent,
  Package
} from 'packages/types';

type Props = {
  packages: CelebrationPackage[];
  allServices: Service[];
  PackageSelectComponent?: PackageSelectComponent;
  onPackageViewed?: (pkg: Package) => void;
};

type SinglePackageProps = {
  pkg: CelebrationPackage;
  PackageSelectComponent?: PackageSelectComponent;
  onPackageViewed?: (pkg: Package) => void;
};

// No `allServices`: this list declares the prop but has never passed it on,
// unlike the venue and meeting lists.
function SinglePackage(props: SinglePackageProps) {
  return (
    <PackageContainer pkg={props.pkg} onPackageViewed={props.onPackageViewed}>
      <PackageDetails
        pkg={props.pkg}
        PackageSelectComponent={props.PackageSelectComponent}
      />
    </PackageContainer>
  );
}

export function CelebrationPackageList(props: Props): ReactElement {
  return (
    <PackagesByCategory
      categoryLabels={CelebrationPackageCategoryLabels}
      packages={props.packages}
      PackageGroup={PackageGroup}
      Package={SinglePackage}
      packageProps={{
        PackageSelectComponent: props.PackageSelectComponent,
        onPackageViewed: props.onPackageViewed
      }}
    />
  );
}
